module.exports = __webpack_public_path__ + "static/media/monteur.761615ff.png";